import {
  Component,
  CUSTOM_ELEMENTS_SCHEMA,
  EventEmitter,
  input,
  Output,
  ViewEncapsulation,
} from '@angular/core';

@Component({
  selector: 'app-button',
  imports: [],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  templateUrl: './button.component.html',
  styleUrl: './button.scss',
  // eslint-disable-next-line no-view-encapsulation-none/no-view-encapsulation-none
  encapsulation: ViewEncapsulation.None,
})
export class Button {
  buttonVariation = input<string>('solid');
  additionalClasses = input<string>('');
  disabled = input<boolean>(false);
  @Output() readonly buttonClickEvent = new EventEmitter<void>();

  handleClick() {
    if (!this.disabled()) {
      this.buttonClickEvent.emit();
    }
  }
}
